import { configureStore } from "@reduxjs/toolkit";
import commonplaceReducer from "./commonplace";
import userInfoReducer from "./userInfo";
import currentHospitalReducer from "./currentHospital";

export default configureStore({
  reducer: {
    commonplace: commonplaceReducer,
    userInfo: userInfoReducer,
    currentHospital: currentHospitalReducer,
  },
});
